import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogModel } from '../../../models/dialog-model.model';
import { MatButtonModule } from '@angular/material/button';
import { Component, Inject } from '@angular/core';

@Component({
    selector: 'app-minster-injury-dialog',
    standalone: true,
    imports: [MatButtonModule, MatDialogModule],
    templateUrl: './minster-injury-dialog.component.html',
    styleUrls: ['./minster-injury-dialog.component.css']
})

export class MinsterInjuryDialogComponent {
    title?: string;
    message?: string;
    
    constructor(
        public dialogRef: MatDialogRef<MinsterInjuryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogModel
    ) {
        this.title = data.title;
        this.message = data.message;
    }
    
    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onDismiss(): void {
        this.dialogRef.close(false);
    }
}
